import {
  Grid,
  Box,
  Typography,
  FormControl,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  SelectChangeEvent
} from '@mui/material'
import { FC, ReactNode, useState } from 'react'
import { DatePickerComponent } from '../../components/DatePicker/DatePickerComponent'
import Slots from './Slots'
import { useStyles } from './style'
import ClockIcon from '../../images/clockIcon.svg'

const HorizontalLine = () => {
  return (
    <Box
      sx={{
        width: '100%',
        border: '0.5px solid #C9C5CA'
      }}
    ></Box>
  )
}
const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 3.5 + ITEM_PADDING_TOP,
      width: 172
    }
  }
}

interface EventDateAndTimeProps {
  eventName: string
  minimumDate?: Date
  maximumDate?: Date
  eventDate: Date
  duration: number | string
  setEventDate: any
  setLiveSlot?: any
  setDrySlot?: any
  handleDuration:
    | ((event: SelectChangeEvent<any>, child: ReactNode) => void)
    | undefined
  selectedSlot: string
  availableSlots: string[]
  clickSlot: any
  blockedDates: string[]
  faqTime: React.ReactNode | string
  faqDate: React.ReactNode | string
}

export const EventDateAndTime: FC<EventDateAndTimeProps> = ({
  eventName,
  minimumDate,
  maximumDate,
  eventDate,
  duration,
  setEventDate,
  setLiveSlot,
  setDrySlot,
  handleDuration,
  selectedSlot,
  availableSlots,
  clickSlot,
  blockedDates,
  faqTime,
  faqDate
}: any) => {
  const classes = useStyles()

  const [openSlot, setOpenSlot] = useState(false)
  return (
    <>
      {/* Live Event Date */}
      <Grid item sm={12}>
        <Box className={classes.eventTitle}>
          <Typography align='left' variant='h5'>
            {eventName} Date
          </Typography>
        </Box>
      </Grid>
      <Grid
        item
        sm={12}
        container
        sx={{
          gridAutoFlow: 'row',
          justifyContent: {
            xs: 'center',
            sm: 'space-between',
            md: 'space-between',
            lg: 'space-between'
          },

          gridRowGap: '2rem'
        }}
      >
        <Box className={classes.datepickerWrapper}>
          <DatePickerComponent
            maximumDate={maximumDate}
            minimumDate={minimumDate}
            eventDate={eventDate!}
            setEventDate={setEventDate}
            setLiveSlot={setLiveSlot}
            setDrySlot={setDrySlot}
            blockedDates={blockedDates}
          />
        </Box>
        <Box sx={{ width: '425px' }}>
          <Typography
            sx={{
              fontSize: '16px !important',
              fontWeight: '400',
              lineHeight: '24px',
              letter: '2%',
              textAlign: { sm: 'left', xs: 'justify' },
              color: '#79747E'
            }}
          >
            {faqDate}
          </Typography>
        </Box>
      </Grid>

      <HorizontalLine />

      {/* Live Event Time */}
      <Grid item sm={12}>
        <Box className={classes.eventTitle}>
          <Typography align='left' variant='h5'>
            {eventName} Time
          </Typography>
        </Box>
      </Grid>
      <Grid
        item
        sm={12}
        container
        sx={{
          gridAutoFlow: 'row',
          justifyContent: {
            xs: 'center',
            sm: 'space-between',
            md: 'space-between',
            lg: 'space-between'
          },
          gridRowGap: '2rem'
        }}
      >
        <Box
          className={classes.datepickerWrapper}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <FormControl
            sx={{
              minWidth: {
                sm: '225px',
                xs: '100%',
                '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
                  {
                    borderColor: '#006BD7'
                  }
                // '& .MuiOutlinedInput-notchedOutline': {
                //   borderRadius: '8px'
                // }
              },
              borderColor: 'red'
            }}
            size='small'
          >
            {(eventName === 'Event' || eventName === 'Event Recording') && (
              <Select
                fullWidth
                value={duration.toString()}
                onChange={handleDuration}
                MenuProps={MenuProps}
              >
                <MenuItem value={0} disabled>
                  Select Duration
                </MenuItem>
                <MenuItem value={30}>30 Minutes</MenuItem>
                <MenuItem value={60}>60 Minutes</MenuItem>
                <MenuItem value={90}>90 Minutes</MenuItem>
              </Select>
            )}

            {eventName === 'Event Dry Run' && (
              <Select
                fullWidth
                value={duration.toString()}
                onChange={handleDuration}
                MenuProps={MenuProps}
              >
                <MenuItem value={0} disabled>
                  Select Duration
                </MenuItem>
                <MenuItem value={30}>30 Minutes</MenuItem>
                <MenuItem value={60}>60 Minutes</MenuItem>
              </Select>
            )}
          </FormControl>

          <TextField
            fullWidth
            label='Time'
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <Box component='img' src={ClockIcon} alt='Clock Icon' />
                </InputAdornment>
              ),
              style: {
                height: '40px',
                width: '225px'
              }
            }}
            onClick={() => {
              setOpenSlot(true)
            }}
            value={selectedSlot}
            sx={{
              '.MuiOutlinedInput-root.Mui-focused': {
                fieldset: { borderColor: '#006BD7' }
              },
              [`& fieldset`]: {
                borderRadius: '8px'
              }
            }}
          />
          <Slots
            open={openSlot}
            setOpen={setOpenSlot}
            selectedSlot={selectedSlot}
            availableSlots={availableSlots}
            setSlot={clickSlot}
          />
        </Box>
        <Box sx={{ width: '425px' }}>
          <Typography
            sx={{
              fontSize: '16px !important',
              fontWeight: '400',
              lineHeight: '24px',
              letter: '2%',
              textAlign: { sm: 'left', xs: 'justify' },
              color: '#79747E'
            }}
          >
            {faqTime}
          </Typography>
        </Box>
      </Grid>

      <HorizontalLine />
    </>
  )
}
